import { SubscriptionProduct } from '@app/subscription/models';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { AsyncStatus } from '@ts/async-state';

export interface SubscriptionProductsState
  extends EntityState<SubscriptionProduct> {
  loadStatus: AsyncStatus;
  error?: unknown;
}

export const SUBSCRIPTION_PRODUCTS_FEATURE_KEY = 'products';

export const subscriptionProductsEntityAdapter =
  createEntityAdapter<SubscriptionProduct>({
    selectId: (product) => product.price_id,
  });

export const initialSubscriptionProductsState: SubscriptionProductsState =
  subscriptionProductsEntityAdapter.getInitialState({
    loadStatus: 'loading',
  });
